import React, { Component } from 'react';
import { ButtonToolbar, Button, FormGroup, ControlLabel, Grid, Row, Col, Tabs, Tab, Table, Panel } from 'react-bootstrap';
import DatePicker from 'react-16-bootstrap-date-picker';
import Select from "react-select";
import { PropTypes } from 'prop-types';

import { HandleMessage } from '../../../HandleMessage';
import { TitleRow } from '../../../TitleRow';
import { LoadingSpinner } from '../../../LoadingSpinner';
import { SortIndicator } from '../../../SortIndicator';
import { LinesCommand } from '../../commands/LinesCommand';
import { PathStopsCommand } from '../../commands/PathStopsCommand';
import { SetOfDayTypesCommand } from '../../commands/SetOfDayTypesCommand';
import { SchedulesCommand } from '../../commands/SchedulesCommand';
import { DrawCommand } from '../../commands/DrawCommand';

export class CarrisScheduleGenerator extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        getOwnEdition: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            edition: undefined,
            dependencies: {
                lines: [],
                stops: [],
                schedules: [],
                setOfDayTypes: []
            },
            form: {
                line: undefined,
                stops: [],
                schedules: [],
                referenceDate: new Date().toISOString(),
                hideLoopsChk: true,
                type: 2
            },
            render: {
                tab: 1,
                schedules: []
            },
            sort: {
                column: "code",
                order: "ascending",
            },
            commands: {
                lines: new LinesCommand(),
                stops: new PathStopsCommand(),
                setOfDayTypes: new SetOfDayTypesCommand(),
                schedules: new SchedulesCommand(),
                draw: new DrawCommand()
            },
            actions: {
                isLoadingEdition: true,
                isLoadingLines: true,
                isLoadingSchedules: true,
                isLoadingSetOfDayTypes: true,
                isGenerating: false,
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            }
        };
    }

    componentDidMount() {
        this.context.selectApp('bussched', false);
        this.getSetOfDayTypes();

        const edition = this.context.getOwnEdition();
        edition.addObserver(this);

        this.setState({
            edition: edition
        });
    }

    componentWillUnmount() {
        this.state.edition.removeObserver(this);
    }

    // ----------------------

    startUpdate() {
        const { actions } = this.state;

        actions.isLoadingEdition = true;

        this.setState({
            actions: actions
        });
    }

    endUpdate() {
        const { actions } = this.state;

        actions.isLoadingEdition = false;

        this.setState({
            actions: actions
        });
    }

    updateNetwork() {
        const { actions, form } = this.state;

        actions.isLoadingLines = true;
        form.line = undefined;

        this.setState({
            form: form,
            actions: actions
        }, () => {
            this.getLines(this.state.edition);
            this.onChangeLineSelected();
        });
    }

    updatePlanning() {
        const { actions, render } = this.state;

        actions.isLoadingSchedules = true;
        render.schedules = [];

        this.setState({
            actions: actions,
            render: render
        }, () => {
            this.getSchedules(this.state.edition);
        });
    }

    // ----------------------

    getLines(edition) {
        const { actions, commands } = this.state;
        commands.lines.list(
            edition.network,
            (a) => this.listSuccessCallback(a, "lines", "isLoadingLines"),
            (a) => this.listErrorCallback(a, "lines", "isLoadingLines")
        );

        actions.isLoadingLines = true;

        this.setState({
            actions: actions
        });
    }

    getStops(edition) {
        const { form, actions, commands } = this.state;

        commands.stops.listStops(
            edition.network,
            form.line.id,
            (a) => this.listSuccessCallback(a, "stops", "isLoadingStops"),
            (a) => this.listErrorCallback(a, "stops", "isLoadingStops")
        );

        actions.isLoadingStops = true;

        this.setState({
            actions: actions
        });
    }

    getSetOfDayTypes() {
        const { actions, commands } = this.state;

        commands.setOfDayTypes.listFull(
            (a) => this.listSuccessCallback(a, "setOfDayTypes", "isLoadingSetOfDayTypes"),
            (a) => this.listErrorCallback(a, "setOfDayTypes", "isLoadingSetOfDayTypes")
        );

        actions.isLoadingSetOfDayTypes = true;

        this.setState({
            actions: actions
        });
    }

    getSchedules(edition) {
        const { actions, commands } = this.state;

        commands.schedules.list(
            edition.planning,
            (a) => this.listSuccessCallback(a, "schedules", "isLoadingSchedules", () => this.filterSchedules()),
            (a) => this.listErrorCallback(a, "schedules", "isLoadingSchedules")
        );

        actions.isLoadingSchedules = true;

        this.setState({
            actions: actions
        });
    }

    // ----------------------

    listSuccessCallback(result, dataType, action, callback = undefined) {
        const { dependencies, actions } = this.state;

        actions[action] = false;
        dependencies[dataType] = result;

        // Update data
        this.setState({
            dependencies: dependencies,
            actions: actions
        }, () => {
            if ("function" === typeof callback) {
                callback();
            }
        });
    }

    listErrorCallback(messageReceived, dataType, action) {
        const { dependencies, actions, message } = this.state;

        actions[action] = false;
        dependencies[dataType] = [];

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            dependencies: dependencies,
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    generationSuccessCallback(messageReceived) {
        const { actions, message } = this.state;

        actions.isGenerating = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });
    }

    generationErrorCallback(messageReceived) {
        const { actions, message } = this.state;

        actions.isGenerating = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // ----------------------

    onChangeSort(column) {
        const { sort } = this.state;

        if (sort.column === column) {
            sort.order = sort.order === "ascending" ? "descending" : "ascending";
        } else {
            sort.column = column;
            sort.order = "ascending";
        }

        this.setState({
            sort: sort
        });
    }

    onSelectValue(e, property, callback = undefined) {
        const { form } = this.state;

        form[property] = e;

        this.setState({
            form: form
        }, () => {
            if ("function" === typeof callback) {
                callback();
            }
        });
    }

    onChangeReferenceDateChange(date) {
        const { form } = this.state;

        form.referenceDate = date;

        this.setState({
            form: form,
        }, () => {
            const { edition } = this.state;
            edition.update(new Date(date));
        });
    }

    onSelectAllStops() {
        const { dependencies, form } = this.state;

        if (form.stops.length === dependencies.stops.length) {
            form.stops = [];
        }
        else {
            form.stops = dependencies.stops
                .map(stop => stop.id);
        }

        this.setState({
            form: form
        });
    }

    onStopRowClick(stop) {
        const { form } = this.state;

        if (form.stops.includes(stop)) {
            form.stops = form.stops
                .filter(formStop => formStop !== stop);
        }
        else {
            form.stops.push(stop);
        }

        this.setState({
            form: form
        });
    }

    onSelectAllSchedules(setOfDayTypesSchedules) {
        const { form } = this.state;
        const setOfDayTypesSchedulesIds = setOfDayTypesSchedules.map(setSchedule => setSchedule.id);

        if (setOfDayTypesSchedulesIds.every(setScheduleId => form.schedules.includes(setScheduleId))) {
            form.schedules = form.schedules
                .filter(schedule => !setOfDayTypesSchedulesIds.includes(schedule));
        }
        else {
            form.schedules = form.schedules.concat(setOfDayTypesSchedulesIds);
        }

        this.setState({
            form: form
        });
    }

    onScheduleRowClick(schedule) {
        const { form } = this.state;

        if (form.schedules.includes(schedule)) {
            form.schedules = form.schedules
                .filter(formSchedule => formSchedule !== schedule);
        }
        else {
            form.schedules.push(schedule);
        }

        this.setState({
            form: form
        });
    }

    onGenerateClick() {
        const { form } = this.state;

        if (form.schedules.length === 0) {
            this.setState({
                message: {
                    show: true,
                    title: "Aviso",
                    message: "Antes de gerar é necessário selecionar pelo menos um horário.",
                    style: "warning",
                    icon: "alert"
                }
            });
            return;
        }

        const { actions } = this.state;

        if (form.stops.length === 0) {
            this.setState({
                message: {
                    show: true,
                    title: "Aviso",
                    message: "Antes de gerar é necessário selecionar pelo menos uma paragem.",
                    style: "warning",
                    icon: "alert"
                }
            });
            return;
        }

        const { commands } = this.state;
        const data = {
            line: form.line.id,
            stops: form.stops,
            schedules: form.schedules,
            referenceDate: form.referenceDate,
            hideLoopsChk: form.hideLoopsChk,
            type: form.type,
        };

        actions.isGenerating = true;
        commands.draw.generateCarrisSched(
            data,
            (a) => this.generationSuccessCallback(a),
            (a) => this.generationErrorCallback(a)
        );

        this.setState({
            actions: actions
        });
    }

    onChangeLineSelected() {
        const { edition, form } = this.state;

        if (undefined === form.line || null === form.line) {
            form.stops = [];
            form.schedules = [];
        }
        else {
            this.getStops(edition);
            this.filterSchedules();
        }

        this.setState({
            form: form
        });
    }

    onTabSelected(key) {
        const { render } = this.state;

        render.tab = key;

        this.setState({
            render: render
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    // ----------------------

    sort(first, second) {
        const { sort } = this.state;

        var a = (first)[sort.column];
        var b = (second)[sort.column];

        if (a === undefined && b === undefined) {
            return 0;
        } else if (a === undefined) {
            if (sort.order === "ascending") {
                return 1;
            } else {
                return -1;
            }
        } else if (b === undefined) {
            if (sort.order === "ascending") {
                return -1;
            } else {
                return 1;
            }
        }

        if (sort.order === "ascending") {
            return typeof a === 'number' ? a - b : a.localeCompare(b);
        }
        return typeof b === 'number' ? b - a : b.localeCompare(a);
    }

    filterSchedules() {
        const { form, dependencies, render } = this.state;

        if (undefined === form.line) {
            render.schedules = [];
        }
        else {
            render.schedules = dependencies.schedules
                .filter(schedule => Array.isArray(schedule.lines) && schedule.lines.includes(form.line.id));
        }

        this.setState({
            render: render
        });
    }

    // ----------------------

    renderEditionLoadingFeedback(isLoadingEdition) {
        return (
            <HandleMessage
                title="A Carregar a Edição..."
                message={<LoadingSpinner />}
                style={`primary`}
                icon="transfer"
                show={isLoadingEdition}
                small
                noButtons />
        );
    }

    renderGeneratingFeedback(isGenerating) {
        return (
            <HandleMessage
                title="A Gerar..."
                message={<LoadingSpinner />}
                style={`primary`}
                icon="transfer"
                show={isGenerating}
                small
                noButtons />
        );
    }

    renderForm() {
        const { dependencies, form } = this.state;

        return (
            <Grid className="margin-top-15" fluid>
                <FormGroup controlId="formLine">
                    <Row>
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Linha</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Linha selecionada"
                                noOptionsMessage={() => "Sem Linhas Configurados"}
                                onChange={(e) => this.onSelectValue(e, "line", (a) => { this.onChangeLineSelected(a); })}
                                options={dependencies.lines}
                                isMulti={false}
                                isClearable={true}
                                isOptionSelected={function (a) {
                                    return form.line === a.id;
                                }}
                                getOptionValue={value => value}
                                getOptionLabel={label => `${label.code} | ${label.goName}`}
                                value={form.line}
                            />
                        </Col>
                    </Row>
                    <Row className="padding-top-7">
                        <Col sm={3} md={2}>
                            <ControlLabel className="padding-top-10">Data de Referência</ControlLabel>
                        </Col>
                        <Col sm={9} md={10}>
                            <DatePicker
                                id="referenceDateDatePicker"
                                dateFormat="DD/MM/YYYY"
                                value={form.referenceDate}
                                placeholder="Data de Referência"
                                onChange={(e) => this.onChangeReferenceDateChange(e)} />
                        </Col>
                    </Row>
                </FormGroup>
            </Grid>
        );
    }

    renderOrientationLabel(orientation) {
        let output = "";

        switch (orientation) {
            case 'C':
                output = "Circular";
                break;

            case 'R':
                output = "Volta";
                break;

            case 'G':
                output = "Ida";
                break;

            case undefined:
                output = "Não Definido";
                break;

            default:
                output = "Ambos";
                break;
        }

        return output;
    }

    renderStopsTab(isLoadingStops, stopsList, selectedStops) {
        if (isLoadingStops) {
            return <LoadingSpinner />;
        }

        const { sort } = this.state;

        return (
            <Table responsive striped hover>
                <thead>
                    <tr>
                        <th className="width-20p" onClick={() => this.onChangeSort('code')}>
                            Código {sort.column === "code" ? <SortIndicator order={sort.order} /> : <SortIndicator order="none" />}
                        </th>
                        <th className="width-60p" onClick={() => this.onChangeSort('name')}>
                            Nome {sort.column === "name" ? <SortIndicator order={sort.order} /> : <SortIndicator order="none" />}
                        </th>
                        <th className="width-20p">
                            Orientação
                        </th>
                        <th>
                            <Button bsSize="small" className="pull-right" onClick={() => this.onSelectAllStops()}>SELECIONAR TUDO</Button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        stopsList.sort((a, b) => this.sort(a, b)).map((stop, idx) =>
                            <tr key={`stop-${idx}`}
                                className={`busched selectable ${selectedStops.includes(stop.id) ? "checked" : ""}`}
                                onClick={() => this.onStopRowClick(stop.id)}>
                                <td>{stop.code !== 'undefined' ? stop.code : ''}</td>
                                <td>{stop.name !== 'undefined' ? stop.name : ''}</td>
                                <td colSpan={2}>{this.renderOrientationLabel(stop.orientation)}</td>
                            </tr>
                        )
                    }
                </tbody>
            </Table>
        );
    }

    renderSetOfDayTypesRow(edition, schedules, form, setOfDayTypes, idx) {
        const setOfDayTypesSchedules = schedules.filter(schedule => setOfDayTypes.id === schedule.setOfDayTypes.id);
        if (0 === setOfDayTypesSchedules.length) {
            return null;
        }

        return (
            <Grid key={`day-type-schedules-${idx}`} fluid>
                <Row>
                    <Col sm={2}>
                        <div className="margin-top-15 padding-top-7 control-label">
                            {setOfDayTypes.name}
                        </div>
                    </Col>
                    <Col sm={10} className="table-small-screens">
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th className="width-70p">Nome</th>
                                    <th className="width-30p">Edição</th>
                                    <th><Button bsSize="small" bsStyle="link" className="pull-right" onClick={() => this.onSelectAllSchedules(setOfDayTypesSchedules)}>SELECIONAR TUDO</Button></th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    setOfDayTypesSchedules.map((schedule, index) =>
                                        <tr key={`sched-${index}`}
                                            className={`busched selectable ${form.schedules.includes(schedule.id) ? "checked" : ""}`}
                                            onClick={() => this.onScheduleRowClick(schedule.id)}>
                                            <td>{schedule.name}</td>
                                            <td colSpan={2}>{edition.getPlanningEditionName(schedule.planningEdition)}</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderSchedulesTab(isLoadingSchedules) {
        if (isLoadingSchedules) {
            return <LoadingSpinner />
        }

        const { render, form } = this.state;

        if (0 === render.schedules.length) {
            return (
                <Panel key="noSchedules" className="margin-top-15">
                    <Panel.Heading>
                        <Panel.Title>Atenção</Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>Não existem horários associados à linha selecionada.</Panel.Body>
                </Panel>
            );
        }

        const { edition, dependencies } = this.state;

        return (
            <div>
                {dependencies.setOfDayTypes.map((setOfDayTypes, idx) => this.renderSetOfDayTypesRow(edition, render.schedules, form, setOfDayTypes, idx))}
            </div>
        );
    }

    renderBody() {
        const { form } = this.state;

        if (undefined === form.line || null === form.line) {
            return null;
        }

        const { dependencies, render, actions } = this.state;

        return (
            <Tabs id="bussched_tabs" activeKey={render.tab} onSelect={(a) => this.onTabSelected(a)}>
                <Tab eventKey={1} key="geral" title="Paragens">
                    {this.renderStopsTab(actions.isLoadingStops, dependencies.stops, form.stops)}
                </Tab>

                <Tab eventKey={2} key="sched" title="Horários">
                    {this.renderSchedulesTab(actions.isLoadingSchedules)}
                </Tab>
            </Tabs>
        );
    }

    renderContent(isWaiting) {
        if (isWaiting) {
            return (
                <LoadingSpinner />
            );
        }

        return (
            <Grid fluid>
                {this.renderForm()}
                {this.renderBody()}
            </Grid>
        );
    }

    render() {
        const { actions, message } = this.state;

        return (
            <div>
                <TitleRow title="Gerar Horáeeerio" showSeparator={true}>
                    <Col className="padding-0">
                        <ButtonToolbar className="pull-right">
                            <Button onClick={() => this.onGenerateClick()}>GERAR</Button>
                        </ButtonToolbar>
                    </Col>
                </TitleRow>

                {this.renderContent(actions.isLoadingLines || actions.isLoadingSetOfDayTypes)}
                {this.renderGeneratingFeedback(actions.isGenerating)}
                {this.renderEditionLoadingFeedback(actions.isLoadingEdition)}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/schedules/carris/CarrisScheduleGenerator.js